import { ActionFunctionArgs, LoaderFunctionArgs, redirect } from "react-router-dom";
import { myAxios } from "src/components/common/functions";

export async function formRecordsLoader(
    { params, request }: LoaderFunctionArgs
){
    const controller = new AbortController();
    request.signal.addEventListener("abort", () => {
        controller.abort();
    });
    const { id } = params;
    if(!id){
        throw new Response("Missing formId", { status: 400 });
    }
    const url = new URL(request.url);
    const pageParam  = url.searchParams.get("page");
    const limitParam = url.searchParams.get("limit");
    let shouldRedirect = false;
    if (!pageParam) {
        url.searchParams.set("page", "1");
        shouldRedirect = true;
    }
    if (!limitParam) {
        url.searchParams.set("limit", "10");
        shouldRedirect = true;
    }
    if (shouldRedirect) throw redirect(url.pathname + "?" + url.searchParams.toString());
    const page  = Number(url.searchParams.get("page"));
    const limit = Number(url.searchParams.get("limit"));
    const fd = new FormData();
    fd.append("formId", id);
    fd.append("page", String(page));
    fd.append("limit", String(limit));
    const res = await myAxios({
        fileName: "forms/readRecords.php",
        formData: fd, 
        signal: controller.signal
    });
    if (!res) throw redirect("/Forms");
    return {
        records: res.data.items,
        total: res.data.total,
        formName: res.data.formName, 
        formType: res.data.formType, 
    };
}

export async function formRecordLoader({ params, request }: LoaderFunctionArgs) {
    const controller = new AbortController();
    request.signal.addEventListener("abort", () => {
        controller.abort();
    });
    const { record_id } = params;
    if (!record_id) {
        console.log("Missing record_id", record_id);
        throw new Response("Missing record_id", { status: 400 });
    }
    const fd = new FormData();
    fd.append("record_id", record_id);
    const res = await myAxios({
        fileName: "forms/readRecord.php",
        formData: fd, 
        signal: controller.signal
    });
    if(!res) throw redirect("..");
    return {
        schema: res.data.schema, 
        values: res.data.values, 
        record_id: Number(record_id), 
        record_name: res.data.record_name,
        pdfId: res.data.pdfId,
    };
}

export async function formSchemaLoader({ request, params }: LoaderFunctionArgs) {
    const controller = new AbortController();
    request.signal.addEventListener("abort", () => {
        controller.abort();
    });
    const { id } = params;
    if(!id){
        throw new Response("Missing form id", { status: 400 });
    }
    const fd = new FormData();
    fd.append("id", id);
    const res = await myAxios({
        fileName: "forms/readForm.php",
        formData: fd, 
        signal: controller.signal
    });
    if(!res) return;
    return {
        schema: res.data, // { form, fields }
        values: {}, 
        mode: "add" as const, 
        formId: Number(id)
    };
}

export async function formRecordAction({ request }: ActionFunctionArgs) {
    const controller = new AbortController();
    request.signal.addEventListener("abort", () => {
        controller.abort();
    });
    const formData = await request.formData();
    const formId = formData.get("formId");
    const record_id = formData.get("record_id");
    if(!formId){
        throw new Response("Missing formId", { status: 400 });
    }
    const values: Record<string, FormDataEntryValue | FormDataEntryValue[]> = {};
    for(const [key, value] of formData.entries()){
        if (["formId", "record_id", "record_name"].includes(key)) continue;
        if (values[key] === undefined) {
            values[key] = value;
        } else if (Array.isArray(values[key])) {
            (values[key] as FormDataEntryValue[]).push(value as string);
        } else {
            values[key] = [values[key] as FormDataEntryValue, value];
        }
    }
    const payload = {
        formId: Number(formId),
        record_name: formData.get("record_name") as string,
        ...(record_id && { record_id: Number(record_id) }),
        values
    };
    const fileName = record_id
        ? "forms/updateRecord.php"
        : "forms/createRecord.php";
    const fd = new FormData();
    fd.append("data", JSON.stringify(payload));
    const res = await myAxios({
        fileName,
        formData: fd,
        signal: controller.signal
    });
    if(!res) return;
    if(!record_id) throw redirect(`../${res.data.id}`);
    throw redirect("..");
}

export async function deleteRecordAction({ request }: ActionFunctionArgs) {
    const controller = new AbortController();
    request.signal.addEventListener("abort", () => {
        controller.abort();
    });
    const formData = await request.formData();
    const record_id = formData.get("record_id");
    if (!record_id) {
        throw new Response("Missing record_id", { status: 400 });
    }
    const fd = new FormData();
    fd.append("record_id", String(record_id));
    const res = await myAxios({
        fileName: "forms/deleteRecord.php",
        formData: fd, 
        signal: controller.signal
    });
    if(!res) throw redirect("..");
    throw redirect("../..");
}